import api from "../../../../utils/api";
const apiUrl = process.env.REACT_APP_MOCK_RESUME_URL;

export const getAllPlans = async (page = 0, limit = 10, search = "" , hasPurchase = true) => {
    try {
        const sortByParam = hasPurchase ? '&sortBy=purchased_at' : '';
        const res = await api.get(
          `/plans/customPlans/fetch?hasPurchased=${hasPurchase}&page=${page + 1}&size=${limit}${sortByParam}`,
          { baseURL:  apiUrl}
    
        );
        return res;
      } catch (err) {
        return err;
      }
};

export const fetchInvoiceList = async (page = 0, limit = 10, invoiceType = 'standard', search = '') => {
  try {
    const res = await api.get(
      `/payments/customInvoice?page=${page + 1}&size=${limit}&invoiceType=${invoiceType}&search=${search}`,
      { baseURL: apiUrl }
    );
    return res;
  } catch (err) {
    return err;
  }
};

export const searchUser = async (query = "") => {
  try {
    const res = await api.get(
      `/profiles/all/searchuser?query=${query}`,
      {baseURL: apiUrl}
    );
    return res;
  } catch (err) {
    return err;
  }
};

export const DownloadPdf = async (payload = {}) => {
  try {
    const res = await api.post(
      `/payments/customInvoice`,
      payload,
      { baseURL: apiUrl }
    );
    return res;
  } catch (err) {
    return err;
  }
};

export const updateDefaultPlan = async (id, payload) => {
  try {
    const res = await api.put(
      `/plans/customPlans/${id}`,
      payload,
      { baseURL: apiUrl }
    );
    return res;
  } catch (err) {
    return err;
  }
};

export const getDefaultPlans = async (paymentProvider = 'RAZORPAY', page = 0, limit = 10) => {
  try {
    const res = await api.get(
      `/plans/customPlans/fetch?paymentProvider=${paymentProvider}&page=${page + 1}&size=${limit}`,
      { baseURL: apiUrl }
    );
    return res;
  } catch (err) {
    return err;
  }
};

export const getInvoiceSequence = async () => {
  try {
    const res = await api.get(
      `/payments/getInvoiceSequence`,
      { baseURL: apiUrl }
    );
    return res;
  } catch (err) {
    console.error('Error fetching invoice sequence:', err);
    return err;
  }
};

// Updated updateInvoice function using the correct API endpoint
export const updateInvoice = async (formData) => {
  try {
    // Extract invoice ID from formData
    const invoiceId = formData.get('invoiceId');
    
    if (!invoiceId) {
      throw new Error('Invoice ID is required for update');
    }

    // Create a new FormData with all the fields for update (same as DownloadPdf)
    const updateFormData = new FormData();
    
    // Copy all fields from the original formData
    for (let [key, value] of formData.entries()) {
      if (key !== 'invoiceId') { // Don't include invoiceId in the body
        updateFormData.append(key, value);
      }
    }

    console.log('Update FormData being sent:');
    for (let [key, value] of updateFormData.entries()) {
      if (key === 'file') {
        console.log(`${key}: PDF File (${value.size} bytes) - ${value.name}`);
      } else {
        console.log(`${key}: "${value}"`);
      }
    }

    const res = await api.patch(
      `/payments/customInvoice/${invoiceId}`,
      updateFormData,
      { 
        baseURL: apiUrl,
        headers: {
      
        }
      }
    );
    return res;
  } catch (err) {
    console.error('Error updating invoice:', err);
    return err;
  }
};